/**************************************************
 * hooks/dash/useFileUpload.js
 *
 * @author  LSJ
 * @since   1.0 (2025-03-05)
 * @version 1.0
 **************************************************/
import { useMutation } from "@tanstack/react-query";
import { fetchData } from "@utils/dashboardApi";

/**
 * useFileUpload
 *
 * 파일 업로드를 위한 커스텀 훅으로, FormData와 필요한 파라미터를 받아 업로드 API를 호출합니다.
 *
 * @returns {object} { mutate, isLoading, isError, error, data }
 */
const useFileUpload = () => {
  const mutation = useMutation(({ formPayload, params }) => {
    // "post" 방식으로 파일 업로드 API 호출 (예: "/user/dash/preventFile")
    return fetchData("/user/dash/preventFile", params, "post", formPayload, {
      timeout: 30000,
    });
  });

  return mutation;
};

export default useFileUpload;
